import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ImportButton from './importButton';
import { UserEditFormMode } from '../../../../services/enums/users';
import AuthenticationProviderType from '../../../../services/enums/authenticationProviderType';

@inject('translationsStore', 'authenticationProvidersStore') @observer
export default class ImportUserButtonContainer extends Component {
  
    authenticationProvidersStore = this.props.authenticationProvidersStore;

    state = {
        showImportUserDialog: false
    };

    componentDidMount() {

        this.authenticationProvidersStore.getAllAuthenticationProviders();
    }

    shouldDisplayLink = () => {

        const servers = this.authenticationProvidersStore.authenticationProviders.filter(s => {
            
            return s.active === true
                && (s.providerType.toLowerCase() === AuthenticationProviderType.LDAP.toLowerCase()
                || s.providerType.toLowerCase() === AuthenticationProviderType.Domain.toLowerCase());
        });

        return servers && servers.length > 0 ? true : false;
    }

    render() {
        
        if (this.props.formMode === UserEditFormMode.edit 
                || this.authenticationProvidersStore.authenticationProviders === undefined) {
            
            return null;
        }

        if (this.shouldDisplayLink() === false) {
            
            return null;
        }

        return (
            <ImportButton
                text={this.props.translationsStore.translate('IMPORT_FROM_DIRECTORY')}
                openImportUserDialog={this.props.openImportUserDialog}
            />
        )
    }
}